export default "__VITE_ASSET__DsvCpPlN__"